<template>
  <v-table
    url="/api/v1/transaction"
    :filter="filter"
    :attributes="[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'customer_profile',
        name: 'Mitglied',
        type: 'LinkProfileCell',
        sortable: false
      },
      {
        type: 'DateTimeCell',
        attribute: 'created_at',
        name: 'Erstellt'
      },
      {
        type: 'DateTimeCell',
        attribute: 'paid_at',
        name: 'Bezahlt'
      },
      {
        attribute: 'amount',
        name: 'Einheiten'
      },
      {
        type: 'CurrencyCell',
        attribute: 'price',
        name: 'Preis'
      },
      {
        attribute: 'service_string',
        name: 'Methode',
        type: 'ServiceStringCell',
        sortable: false
      },
      {
        type: 'ManualTransactionCell',
        attribute: 'was_created_by_admin',
        name: 'Manuell?'
      },
      {
        type: 'TransactionConfirmCell',
        attribute: 'state',
        name: 'Gebucht?'
      }
    ]"
    ref="table"
  >
    <div slot="filter">
      <table-filter
        :filterComponents="[
          {
            type: 'DropdownFilter',
            label: 'Zahlungsart- / Dienstleister',
            options: serviceOptions,
            attributes: 'service'
          },
          {
            type: 'DateFilter',
            label: 'Datum von',
            attributes: { column: 'updated_at', operator: '>=' }
          },
          {
            type: 'DateFilter',
            label: 'Datum bis',
            attributes: { column: 'updated_at', operator: '<=' }
          },
          {
            type: 'WhereFilter',
            label: 'ID',
            attributes: 'id'
          },
          {
            type: 'WhereFilter',
            label: 'Profile-ID',
            attributes: 'customer_profile_id'
          },
          {
            type: 'WhereLikeFilter',
            label: 'Kunde',
            attributes: 'customerProfile.name'
          }
        ]"
        v-model="filter"
        @apply-filters="$bus.$emit('refresh-table', $refs.table.id)"
      ></table-filter>
    </div>
  </v-table>
</template>

<script lang="babel">
import { dynamicSort } from "@/js/sort";
export default {
  created() {
    this.$http.get("/api/v1/transaction/meta").then(({ data }) => {
      this.meta = data;
    });
  },
  data () {
    return {
      meta: null,
      allStateServicesFilter: [
        {
          name: "where-in",
          attributes: [
            {
              column: "service",
              values: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18],
            },
            {
              column: "state",
              values: [ 0,1 ],
            }
          ]
        }],
      filter: [
        {
          name: "with",
          value: "customerProfile",
        },
        {
          name: "sort",
          mode: "DESC",
          attribute: "updated_at"
        },
        {
          name: "where-in",
          attributes: [
            {
              column: "service",
              values: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18],
            }
          ]
        },
      ]
    };
  },

  computed: {
    serviceOptions() {
      let serviceOptions = [];
      if (this.meta) {
        let selectableServices = this.meta["attributes-options"]["selectable-services"];
        let serviceKeys = Object.keys(selectableServices);
        serviceOptions = serviceOptions.concat(serviceKeys.map(serviceKey => {
          return { filter: [{ name: "where-in", attributes: [ { column: "service", values: [serviceKey] }, { column: "state", values: [0,1] }]}], label: this.$store.getters["transaction/dictionaryEntry"](selectableServices[serviceKey]) };
        }));
      }

      serviceOptions.push({ filter: [{ name: "where-in", attributes: [ { column: "service", values: [3] }, { column: "state", values: [0] }]}], label: "Vorkasse (gebucht)"});
      serviceOptions.push({ filter: [{ name: "where-in", attributes: [ { column: "service", values: [3] }, { column: "state", values: [1] }]}], label: "Vorkasse (ungebucht)"});
      serviceOptions = serviceOptions.sort(dynamicSort("label"));
      serviceOptions.unshift({ filter: this.allStateServicesFilter, label: "Alle" });
      return serviceOptions;
    }
  }
};
</script>
